"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof")),
    _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _reactFiles = _interopRequireDefault(require("react-files")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _classnames = _interopRequireDefault(require("classnames")),
    _AssetPreview = _interopRequireDefault(require("../../AssetPreview")),
    _EmbedCodeSource = _interopRequireDefault(require("./EmbedCodeSource")),
    _FileDescription = _interopRequireDefault(require("./FileDescription")),
    _constants = require("../constants");

require("../styles/_upload-files-modal.scss");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return "symbol" === (0, _typeof2["default"])(key) ? key : key + "";
}

function _toPrimitive(input, hint) {
  if ("object" !== (0, _typeof2["default"])(input) || null === input) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if ("object" !== (0, _typeof2["default"])(res)) return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === hint ? String : Number)(input);
}

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var UploadFilesModal = function (_Component) {
  function UploadFilesModal(props) {
    var _this;

    return (0, _classCallCheck2["default"])(this, UploadFilesModal), _this = _super.call(this, props), _this.handleFileRemoval = (0, _lodash["default"])(function (id) {
      return function (e) {
        e.preventDefault(), e.stopPropagation();
        var _this$state$selectedF = _this.state.selectedFiles,
            idToRemove = _this$state$selectedF[id],
            newFiles = (0, _objectWithoutProperties2["default"])(_this$state$selectedF, [id].map(_toPropertyKey));

        _this.setState({
          selectedFiles: newFiles
        });
      };
    }), _this.getTitle = (0, _lodash["default"])(function (beforeText) {
      return "".concat(beforeText, " File").concat(_this.isSingleFileAllowed() ? "" : "s");
    }), _this.isMaxFilesSelected = function () {
      var maxFiles = _this.props.maxFiles,
          selectedFiles = _this.state.selectedFiles;
      return !!(maxFiles && 1 !== maxFiles && Object.keys(selectedFiles).length === maxFiles);
    }, _this.isSingleFileAllowed = function () {
      var maxFiles = _this.props.maxFiles;
      return 1 === maxFiles;
    }, _this.handleBrowseFilesClick = function () {
      _this._filesRef && _this._filesRef.openFileChooser();
    }, _this.handleFilesSelect = function (files) {
      if (files && files.length) {
        var selectedFiles = _this.state.selectedFiles,
            newSelectedFiles = files.filter(function (file) {
          return file && !selectedFiles[file.id];
        });
        _this._filesRef.removeFiles(), newSelectedFiles.forEach(_this.uploadAsset);
      }
    }, _this.uploadAsset = function () {
      var _ref = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(file) {
        var _this$props, addFileToQueue, organisationId, isSingleFileAllowed, selectedFile, id, assetId;

        return _regenerator["default"].wrap(function (_context) {
          for (;;) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this$props = _this.props, addFileToQueue = _this$props.addFileToQueue, organisationId = _this$props.organisationId, isSingleFileAllowed = _this.isSingleFileAllowed(), selectedFile = file.id ? {
                  asset: {
                    title: file.name,
                    metaData: JSON.stringify({
                      type: file.type,
                      size: file.size
                    })
                  },
                  valid: !1
                } : _objectSpread({}, file, {
                  valid: !0
                }), id = file.id || Date.now(), _this.setState(function (_ref2) {
                  var selectedFiles = _ref2.selectedFiles;
                  return {
                    selectedFiles: isSingleFileAllowed ? (0, _defineProperty2["default"])({}, id, selectedFile) : _objectSpread({}, selectedFiles, (0, _defineProperty2["default"])({}, id, selectedFile))
                  };
                }), file.id) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                return _context.next = 9, addFileToQueue({
                  file: file,
                  metaData: {
                    type: file.type,
                    size: file.size
                  }
                }, organisationId);

              case 9:
                assetId = _context.sent, _this.setState(function (_ref4) {
                  var selectedFiles = _ref4.selectedFiles;
                  return {
                    selectedFiles: isSingleFileAllowed ? (0, _defineProperty2["default"])({}, id, {
                      assetId: assetId,
                      valid: !0
                    }) : _objectSpread({}, selectedFiles, (0, _defineProperty2["default"])({}, id, {
                      assetId: assetId,
                      valid: !0
                    }))
                  };
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }(), _this.handleSave = function () {
      var onSave = _this.props.onSave,
          selectedFiles = _this.state.selectedFiles;
      return _this.setState({
        selectedFiles: {}
      }), onSave(Object.values(selectedFiles));
    }, _this.renderDragZoneContent = function () {
      var selectedFiles = _this.state.selectedFiles;
      return Object.keys(selectedFiles).length ? _react["default"].createElement("div", {
        className: "upload-files-modal__assets"
      }, Object.entries(selectedFiles).map(function (_ref6) {
        var _ref7 = (0, _slicedToArray2["default"])(_ref6, 2),
            id = _ref7[0],
            file = _ref7[1];

        return _react["default"].createElement("div", {
          key: id,
          className: "upload-files-modal__assets__asset"
        }, file.asset || file.assetId ? _react["default"].createElement(_AssetPreview["default"], (0, _extends2["default"])({}, file, {
          height: 75,
          width: 75
        })) : _react["default"].createElement(_uiKit.Image, {
          defaultImageIcon: "embed",
          width: "75px",
          height: "75px",
          defaultIconColour: "russian",
          defaultIconSize: 35
        }), _react["default"].createElement(_FileDescription["default"], file), _react["default"].createElement(_uiKit.Icon, {
          size: 15,
          onClick: _this.handleFileRemoval(id),
          name: "close",
          color: "russian",
          hoverColor: "redApple"
        }));
      })) : _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("p", null, _react["default"].createElement("strong", null, "Upload")), _react["default"].createElement("p", {
        className: "upload-files-modal__content__dnd__drop-zone__text"
      }, _react["default"].createElement("small", null, "Drag & drop your files or"), _react["default"].createElement("span", null, "browse")));
    }, _this.setFilesRef = function (ref) {
      _this._filesRef = ref;
    }, _this.state = {
      selectedFiles: {}
    }, _this;
  }

  (0, _inherits2["default"])(UploadFilesModal, _Component);

  var _super = _createSuper(UploadFilesModal);

  return (0, _createClass2["default"])(UploadFilesModal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          visible = _this$props2.visible,
          modalSubtitle = _this$props2.modalSubtitle,
          onClose = _this$props2.onClose,
          allowEmbed = _this$props2.allowEmbed,
          allowedExtensions = _this$props2.allowedExtensions,
          maxFileSize = _this$props2.maxFileSize,
          maxFiles = _this$props2.maxFiles,
          saveText = _this$props2.saveText,
          selectedFiles = this.state.selectedFiles,
          isSingleFileAllowed = this.isSingleFileAllowed(),
          maxFilesSelected = this.isMaxFilesSelected(),
          maxFilesValue = maxFiles && !isSingleFileAllowed ? maxFiles : void 0;
      return _react["default"].createElement("div", {
        className: "upload-files-modal"
      }, _react["default"].createElement(_uiKit.FormModal, {
        visible: visible,
        saveText: saveText,
        onClose: onClose,
        onSave: this.handleSave,
        title: this.getTitle("Upload"),
        subtitle: modalSubtitle,
        saveDisabled: Object.values(selectedFiles).some(function (file) {
          return !file.valid;
        })
      }, _react["default"].createElement("div", {
        className: "upload-files-modal__content"
      }, _react["default"].createElement("div", {
        className: "upload-files-modal__content__dnd"
      }, _react["default"].createElement("p", null, this.getTitle("Upload")), _react["default"].createElement(_reactFiles["default"], {
        ref: this.setFilesRef,
        className: (0, _classnames["default"])("upload-files-modal__content__dnd__drop-zone", {
          "upload-files-modal__content__dnd__drop-zone--empty": !Object.keys(selectedFiles).length,
          "upload-files-modal__content__dnd__drop-zone--full": maxFilesSelected
        }),
        dropActiveClassName: "upload-files-modal__content__dnd__drop-zone--active",
        onChange: this.handleFilesSelect,
        clickable: !maxFilesSelected,
        multiple: !isSingleFileAllowed,
        accepts: allowedExtensions,
        maxFileSize: maxFileSize,
        maxFiles: maxFilesValue
      }, this.renderDragZoneContent())), _react["default"].createElement("div", {
        className: "upload-files-modal__content__source-from"
      }, _react["default"].createElement("p", null, "or Source From"), _react["default"].createElement(_uiKit.Button, {
        className: "upload-files-modal__content__source-from__button",
        type: "INVERTED",
        disabled: maxFilesSelected,
        onClick: this.handleBrowseFilesClick,
        small: !0
      }, _react["default"].createElement(_uiKit.Icon, {
        name: "computer",
        size: 20
      }), this.getTitle("Browse")), allowEmbed && _react["default"].createElement(_EmbedCodeSource["default"], {
        onSave: this.uploadAsset
      }, _react["default"].createElement(_uiKit.Button, {
        className: "upload-files-modal__content__source-from__button",
        type: "INVERTED",
        disabled: maxFilesSelected,
        small: !0
      }, "< > Embed Code"))))));
    }
  }]), UploadFilesModal;
}(_react.Component);

exports["default"] = UploadFilesModal, UploadFilesModal.defaultProps = {
  maxFileSize: _constants.MAX_FILE_SIZE
};